export class CourseTemplate {
  Id: number;
  Name: string;
  Code: string;
  Type: string;
  Theme: string;
  Description: string;
  UserField1: string;
  UserField2: string;
  UserField3: string;
  UserField4: string;
  UserField5: string;
  UserField6: string;
  UserField7: string;
  UserField8: string;
  UserField9: string;
}
